import React from 'react';
import SimpleRegistrationForm from '../components/SimpleRegistrationForm';
import RegistrationSuccess from './RegistrationSuccess';
import useSimpleRegistration from '../hooks/useSimpleRegistration';

const RegistrationPage: React.FC = () => {
  const {
    formData,
    errors,
    isSubmitting,
    isSuccess,
    handleInputChange,
    handleSubmit,
    resetSuccess
  } = useSimpleRegistration();

  if (isSuccess) {
    return <RegistrationSuccess onRegisterAnother={resetSuccess} />;
  }

  return (
    <div className="uk-section uk-section-large uk-background-muted">
      <div className="uk-container uk-container-small">
        <SimpleRegistrationForm
          formData={formData}
          errors={errors}
          isSubmitting={isSubmitting}
          onInputChange={handleInputChange}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default RegistrationPage;
